var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Toolbar } from '@react-admin/ra-rbac';
/**
 * Replacement for react-admin's Toolbar that adds RBAC control to actions
 *
 * Users must have the 'delete' permission on the resource and record to see the DeleteButton.
 */
export var AccordionFormToolbar = function (props) {
    return (React.createElement(Toolbar, __assign({ sx: {
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            backgroundColor: 'transparent',
        } }, props)));
};
